export { default as MainC } from './components/main';
export { default as AddC } from './components/add';
export { default as PasajerosC } from './components/pasajeros';
export { default as TrayectoViajeC } from './components/mapaTrayecto';



// WEBPACK FOOTER //
// src/modules/viajes/component.js